export default "__VITE_ASSET__CHr34kuJ__"